import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

const { chip, note } = semanticThemeTokens;

export const cell = style({
  display: "inline-flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"]
});

export const badge = style({
  display: "inline-flex",
  alignItems: "center",
  padding: `0 ${primitiveTokens.sizing["2x"]}`,
  borderRadius: primitiveTokens.radii.md,
  borderWidth: primitiveTokens.strokes.md,
  borderStyle: "solid",
  borderColor: chip.borderColor,
  fontSize: primitiveTokens.type.xs,
  textTransform: "none",
  whiteSpace: "nowrap",
  backgroundColor: chip.backgroundColor,
  color: chip.textColor
});

export const tooltip = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["1x"],
  padding: `${primitiveTokens.sizing["2x"]} ${primitiveTokens.sizing["4x"]}`,
  borderRadius: primitiveTokens.radii.md,
  fontSize: primitiveTokens.type.xs,
  whiteSpace: "nowrap",
  backgroundColor: note.info.backgroundColor,
  color: note.info.textColor
});
